import React from 'react';
import '../../index.css';
import './Error.css';

const Error = ({ error }) => {
    return (
        <div className='container-error'>
            {error && <div>{error}</div>}
        </div>
    );
};

export default Error;
